<template>
    <a-card class="OrderDetail">
        <a-form-model layout="inline">
            <a-form-model-item label="输入搜索">
                <a-input placeholder="请输入手机号" allow-clear :maxLength="20" v-model="searchForm.mobile"/>
            </a-form-model-item>
            <a-form-model-item style="margin-left: 35px;">
                <a-button type="primary" @click="getList(1)">查询</a-button>
                <a-button style="margin: 0 35px 0 15px;" @click="resetSearch()">重置</a-button>
            </a-form-model-item>
        </a-form-model>
        <div class="info">
            <span>订单编号：{{$route.query.outOrderId}}</span>
            <span>下单手机号：{{$route.query.mobile}}</span>
        </div>
        <div class="table">
            <a-table style="min-width: 800px;"
                :columns="columns"
                row-key="id"
                :pagination="tableRelevant.tablePagination"
                :loading="tableRelevant.tableLoading"
                :locale="tableRelevant.locale"
                :dataSource="tableRelevant.tableDataSource">
                <div slot="name" slot-scope="text, record" :class="!text.courseId ? 'redName' : ''">
                    {{text.name}}
                </div>
                <div slot="price" slot-scope="text, record">
                    ￥{{text.price}}
                </div>
                <div slot="progress" slot-scope="text, record" class="_flex">
                    <span>{{ text.progress == 0 ? '未开始' : text.progress == 100 ? '已完成' : '进行中'}}</span>
                </div>
                <div slot="mobile" slot-scope="text, record" class="_flex">
                    <span>{{ text.mobile ? text.mobile : '--'}}</span>
                </div>
                <div slot="action" slot-scope="text, record">
                    <a @click="revise(text)" style="margin-right:15px;" v-permission="`Operate.OrderDetail.Update`" v-if="record.enabled">修改</a>
                    <a @click="changeRecord(text)" v-permission="`Operate.OrderDetail.ChangeRecord`">变更记录</a>
                </div>
            </a-table>
        </div>
        <a-modal
            title="修改"
            :visible="form.visible"
            destroyOnClose
            :maskClosable="true"
            :confirm-loading="form.loading"
            @ok="handleOk"
            @cancel="handleCancel">
                <a-form-model
                    ref="ruleForm"
                    :model="form.data"
                    :rules="form.rules"
                    :label-col="{span:6}"
                    :wrapper-col="{span:14}">
                    <a-form-model-item label="当前手机号">
                        <span>{{itemMobile || '--'}}</span>
                    </a-form-model-item>
                    <a-form-model-item label="手机号" prop="mobile">
                        <a-input v-model.trim="form.data.mobile" placeholder="请输入手机号" style="width:100%;"/>
                    </a-form-model-item>
                    <a-form-model-item label="确认手机号" prop="mobile2">
                        <a-input v-model.trim="form.data.mobile2" placeholder="请确认手机号" style="width:100%;"/>
                    </a-form-model-item>
                </a-form-model>
        </a-modal>
        <a-modal
            width="850px"
            title="变更记录"
            :visible="recordVisible"
            destroyOnClose
            :footer="false"
            @cancel="recordCancel"
            :maskClosable="true">
            <a-table
                style="max-height: 400px;overflow-y: auto;"
                :columns="recordColumns"
                row-key="id"
                :pagination="false"
                :dataSource="recordData">
            </a-table>
        </a-modal>
    </a-card>
</template>

<script>
import $Bus from "@/pages/projectImpl/js/eventBus"
import {tableRelevant} from "@/pages/projectImpl/js/utils";

const columns = [
    { title: '商品名称', key: "1", scopedSlots: {customRender: 'name'}},
    { title: '商品金额', key: "2", scopedSlots: {customRender: 'price'}},
    { title: '状态', key: "3", scopedSlots: {customRender: 'progress'}},
    { title: '绑定手机号', key: "5", scopedSlots: {customRender: 'mobile'}},
    { title: '操作', key: "7", scopedSlots: {customRender: 'action'}}
]
const recordColumns = [
    { title: '序号', key: "1", dataIndex: 'id'},
    { title: '变更前', key: "2", dataIndex: 'oLdMobile'},
    { title: '变更后', key: "3", dataIndex: 'newMobile'},
    { title: '变更时间', key: "5", dataIndex: 'changeTime'},
]
export default {
    name:'OrderDetail',
    data () {
        const checkMobile = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入手机号'))
            } else {
                if (!/^1[3456789]\d{9}$/.test(value)) {
                    callback(new Error('请输入正确的手机号'))
                } else if(value == this.itemMobile){
                    callback(new Error('请核对需要修改的手机号'))
                }
                else {
                    callback()
                }
            }
        }
        const checkMobile2 = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请确认手机号'))
            } else {
                if (this.form.data.mobile && value != this.form.data.mobile) {
                    callback(new Error('两次手机号码不一致，请核对'))
                } else {
                    callback()
                }
            }
        }
        return {
            searchForm:{
                mobile:undefined,
            },
            columns,
            tableRelevant: tableRelevant.call(this,this.getList),
            form:{
                visible:false,
                data:{
                    mobile:null,
                    mobile2:null
                },
                rules:{
                    mobile: [{ required: true, validator: checkMobile, trigger: "change" }],
                    mobile2: [{required: true, validator: checkMobile2, trigger: 'change' }],
                }
            },
            recordColumns,
            recordVisible:false,
            recordData:[],
            itemId:'',
            itemMobile:''
        }
    },
    created () {

    },
    mounted(){
        this.setTitle()
        this.getList(1)
    },
    methods: {
        getList(pageIndex){
            let params = {
                ...this.searchForm,
                orderId:this.$route.query.orderId,
                pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                pageSize: this.tableRelevant.tablePagination.pageSize,
            }
            this.tableRelevant.tableLoading = true
            this.$http.operate.GetUserCoursePageList(params)
            .then(res => {
                this.tableRelevant.tableLoading = false
                    this.tableRelevant.tableDataSource = res.data.data.items
                    this.tableRelevant.tablePagination.total = res.data.data.totalCount;
                    this.tableRelevant.tablePagination.current = res.data.data.pageIndex;
               
            })
            .catch(err=>{
                this.tableRelevant.tableLoading = false
            })
        },
        resetSearch(){
            this.searchForm.mobile = undefined
            this.getList(1)
        },
        setTitle(){
            const arr = ["首页","运营中心",{name: "订单管理",path: "/operate/OrderManage"},"订单详情"];
            $Bus.$emit("pageHeaderBreadcrumb", arr);
        },
        revise(text){
            if(!text.customizeCourseId){
                this.$message.destroy();
                this.$message.warning('请完成该商品的关联后，再次尝试')
                return
            }
            this.form.visible = true
            this.itemId = text.itemId
            this.itemMobile = text.mobile
        },
        handleOk(){
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    let formData = new FormData();
                    formData.append('ItemId',this.itemId)
                    formData.append('Mobile',this.form.data.mobile)
                    this.$http.operate.UpdateOrderCourseMobile(formData)
                    .then(res => {
                            this.$message.success('操作成功');
                            this.$refs.ruleForm.resetFields();
                            this.getList(1)
                            this.form.visible = false
                       
                    })
                } else {

                }
            });
        },
        handleCancel(){
            this.$refs.ruleForm.resetFields();
            this.form.visible = false
        },
        changeRecord(text){
            this.recordVisible = true
            let params = {
                itemId:text.itemId
            }
            this.$http.operate.GetChangeRecord(params)
                    .then(res => {
                            this.recordData = res.data.data
                     
                    })
        },
        recordCancel(){
            this.recordVisible = false
        },
    }
}
</script>

<style scoped lang="less">
.info{
    margin-top:15px;
    span:nth-child(2){
        margin-left:30px;
    }
}
.table{
    margin-top:20px;
}
.redName{
    color:#f00;
}
</style>
